/**
 * Delegate form submition to a method
 * @module $_GP.ajaxDelegate
 */
$_GP.ajaxDelegate = (function() {

	/**
	 * Form submition controled by $_GP.privacyControl
	 * @example
		$_GP.ajaxDelegate.privacyControl('#form', {
			url: 'url/to/endpoint'
		});
	 * @param {string|jQuery} form - form element
	 * @param {object} opt - options, $_GP.ajaxSubmitInner options
	 * @returns {undefined}
	 * @requires $_GP.privacyControl, $_GP.ajaxSubmitInner
	 */
	const privacyControl = function(form, opt) {
		form = $(form)
		if (!form.length) return

		if (!form.find('[data-privacy]').length) {
			console.error(`data-privacy in #${form.attr('id')} is required (<input type="hidden" name="txtPrivacy" data-privacy>)!!!`)
			return false
		}

		const modal = $('#modal-privacy');
		let SUBMITING = false;

		form.on('submit', function(ev) {
			ev.preventDefault()
			if (SUBMITING) return

			$_GP.privacyControl.setForm(form)

			if (!$_GP.privacyControl.getPrivacyAgree()) {
				modal.modal('show')
				return false
			}

			if ($_GP.privacyControl.getPrivacyAgree()) {
				SUBMITING = true
				modal.modal('hide');

				$_GP.ajaxSubmitInner(form, opt).always(function() {
					SUBMITING = false;
					form.find('[data-privacy]').val('');
				});
			}

			return false;
		});
	}

	return { privacyControl }
}());
